import fetchProductReviews from "../typesense/reviews/fetchProductReviews";
import fetchProductSummary from "../typesense/reviews/fetchProductSummary";

export const getReviewsByProduct = async (productId, page = 1, pageSize = 3, sortBy, sortDirection) => {
  try {
    const numberProductId = Number(productId);
    const [reviews, summary] = await Promise.all([
      fetchProductReviews(numberProductId, page, pageSize, sortBy, sortDirection),
      fetchProductSummary(numberProductId)
    ]
    )

    return {
      total: 0,
      rating: 0,
      data: [],
      page: 1,
      ...summary,
      ...reviews
    }
  } catch (error) {
    console.log(error);
    return {
      total: 0,
      rating: 0,
      data: [],
      page: 1,
    }
  }
};
